import { ApiResponse } from "types/api";
import { BankType, PlayerBankType } from "types/bank";

import {
  ListBankResponseType,
  ListPlayerBankResponseType,
  PlayerBankFormType,
} from "./type";

const mockBanks: BankType[] = [
  {
    bank_id: "1",
    bank_name: "Ziraat Bankası",
    mobile_image_on: "",
    web_image_on: "",
  },
  {
    bank_id: "2",
    bank_name: "Garanti BBVA",
    mobile_image_on: "",
    web_image_on: "",
  },
  {
    bank_id: "3",
    bank_name: "İş Bankası",
    mobile_image_on: "",
    web_image_on: "",
  },
  {
    bank_id: "4",
    bank_name: "Yapı Kredi",
    mobile_image_on: "",
    web_image_on: "",
  },
  {
    bank_id: "5",
    bank_name: "Akbank",
    mobile_image_on: "",
    web_image_on: "",
  },
  {
    bank_id: "6",
    bank_name: "QNB Finansbank",
    mobile_image_on: "",
    web_image_on: "",
  },
  {
    bank_id: "7",
    bank_name: "DenizBank",
    mobile_image_on: "",
    web_image_on: "",
  },
];

const mockPlayerBanks: PlayerBankType[] = [
  {
    player_bank_id: "1",
    bank_id: "1",
    bank_name: "Ziraat Bankası",
    bank_account_name: "TK88 MEMBER",
    bank_account_no: "998877665544",
    bank_account_address: "Istanbul",
    web_image_on: "",
    mobile_image_on: "",
  },
];

export const BankApi = {
  getListBank: async (_username: string) => {
    return {
      data: {
        status: 0,
        msg: "Success",
        data: mockBanks,
      } as ListBankResponseType,
    };
  },
  getListPlayerBank: async (_username: string) => {
    return {
      data: {
        status: 0,
        msg: "Success",
        data: mockPlayerBanks,
      } as ListPlayerBankResponseType,
    };
  },
  addPlayerBank: async (_username: string, _payload: PlayerBankFormType) => {
    return {
      data: {
        status: 0,
        msg: "Bank account added successfully",
      } as ApiResponse,
    };
  },
};
